<!-- Advertise Message Banner -->

<template>
	<div class="banner-ad-mess-main" @click="goMess">
		<div class="box-left wi8_font">
			Advertise <span class="at-sign">@</span> <br/>
			What I Ate!
		</div>
		<div class="box-right">
			<UniIcon
				ico="message"
				color="#369"
				fit="1"
				pad="0"
			/>
		</div>
	</div>
</template>

<script>
import { m } from "@/utils/utils";
export default {
	methods: {
		goMess() {
			m("go mess");
		
			const data = {
				rec: {
					name: "",
					email: "",
					subj: "Advertising at What I Ate",
					messText: "I would like to advertise at What I Ate! \nHere is more of my info:",
				}
			}

			// Save info, then Post
			this.$store.dispatch("app/setContact", data)
				.then( () => {
					this.$router.push("/contact")
					.catch(err => {
						// nothing, already at path
					})	
				})

		
		}
	},
}
</script>

<style scoped>
.banner-ad-mess-main {
	display: inline-block;
	vertical-align: top;
	width: 150px;
	height: 40px;
	overflow: hidden;
	cursor: pointer;
	border-radius: 5px;
	border: solid 1px #999;
}

.box-left {
	display: inline-block;
	width: 95px;
	height: 38px;
	overflow: hidden;
	white-space: nowrap;
	vertical-align: top;
	padding: 4px 0px 0px 5px;
	font-size: 11px;
	line-height: 15px;
	border: solid 0px #C30;
}

.at-sign {
	font-size: 15px;
}

.box-right {
	float:right;
	width: 50px;
	height: 40px;
	overflow: hidden;
	vertical-align: top;
	font-size: 12px;
	border: solid 0px #000;
}

</style>
